import { useParams, useSearchParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { useUnsubscribeByTokenQuery } from '../../../api/subscribeApi';
import { errMsg } from '../../../utils/errMsg';
import card from '../../../styles/shared/publicCard.module.css';
import styles from '../SubscribePage/SubscribePage.module.css';

export default function UnsubscribeTokenPage() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('group_id') ?? undefined;
  const channel = searchParams.get('channel') ?? undefined;

  const { data, isLoading, isError, error } = useUnsubscribeByTokenQuery({
    token,
    groupId,
    channel,
  });

  return (
    <div className={card.wrapper}>
      <Card className={`${card.card} ${styles.card}`}>
        {isLoading && <p className={card.status}>Unsubscribing…</p>}

        {isError && (
          <p className={card.status}>
            {error?.status === 404
              ? "This unsubscribe link isn't valid or has already been used."
              : errMsg(error, 'Could not unsubscribe. Please try again.')}
          </p>
        )}

        {data?.unsubscribed && (
          <>
            <h2 className={styles.doneTitle}>You&apos;re unsubscribed</h2>
            <p className={card.status}>
              {data.scope === 'all'
                ? `You won't get any more alerts (${data.count ?? 0} group${data.count === 1 ? '' : 's'}).`
                : "You won't get any more alerts for this group."}
            </p>
          </>
        )}
      </Card>
    </div>
  );
}
